import React from 'react';
import {useRoute} from 'wouter';

import {DocumentRouteParams} from '../../interface';

import {DocumentLink} from './document-link';
import {StatusIconSettings} from '../doc-status-icon/document-status-icon';

interface Props {
    documents: EditModeDoc[];
    itemOffset?: number;
    itemMarginLeft?: number;
    statusIconSettings: StatusIconSettings;
}

export const DocumentsList = ({
    documents,
    itemMarginLeft,
    itemOffset,
    statusIconSettings
}: Props) => {
    const [, params] = useRoute<DocumentRouteParams>('/:documentId?/*?');
    const {documentId} = params || {};

    return (
        <>
            {documents.map((doc) => (
                <DocumentLink
                    key={doc.accession}
                    doc={doc}
                    active={doc.accession === documentId}
                    offset={itemOffset}
                    marginLeft={itemMarginLeft}
                    statusIconSettings={statusIconSettings}
                />
            ))}
        </>
    );
};
